// extracted by mini-css-extract-plugin
export default {"subtitle":"Currency_subtitle__goIYV"};